import { useTranslation } from 'react-i18next';
import DownloadIcon from '@/shared/assets/download-16-icon.svg?react';
import { ButtonSmall } from '@/shared/components';

type Props = {
  onClick: () => void;
};

export const HistoryExportButton = ({ onClick }: Props) => {
  const { t } = useTranslation();

  return (
    <ButtonSmall icon={DownloadIcon} onClick={onClick}>
      {t('historyPage.exportStatement')}
    </ButtonSmall>
  );
};
